import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Point } from '@/types';
import { useDeletePointMutation } from '@/services';

export interface DeletePointProps extends DialogProps {
  point: Point;
  onClose(): void;
}

const DeletePoint: React.FC<DeletePointProps> = ({ point, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deletePoint, deletePointResponse] = useDeletePointMutation();

  async function handleDeletePoint() {
    try {
      await deletePoint(point).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{point?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{point?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deletePointResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deletePointResponse.isLoading} onClick={handleDeletePoint}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePoint;
